import { FC } from 'react';
import CompanySuggestion from '~/src/components/common-components/company-suggestion/company-suggestion';
import { COLORS } from '~/src/styles/tokens/colors';
import { SvgClose } from '~/src/components/svg-components/close';
import type { CompanySuggestionProps } from '~/src/components/common-components/company-suggestion/company-suggestion.types';
import * as Styled from './legal-info.styles';

interface LegalInfoProps {
    suggestedOrganization: CompanySuggestionProps;
    onClose: () => void;
}

export const LegalInfo: FC<LegalInfoProps> = ({ suggestedOrganization, onClose }) => {
    return (
        <Styled.LegalInfoWrapper>
            <Styled.CompanySuggestionWrapper>
                <CompanySuggestion {...suggestedOrganization} />
            </Styled.CompanySuggestionWrapper>
            <Styled.ImageWrapper onClick={onClose}>
                <SvgClose color={COLORS.iconsPrimaryClose} />
            </Styled.ImageWrapper>
        </Styled.LegalInfoWrapper>
    );
};
